/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ETypeDashboardDossier {
    SortieApprenant = 'SortieApprenant',
    StatutPostFormation = 'StatutPostFormation',
    FinAgrementProvisoire = 'FinAgrementProvisoire'
}


export function ETypeDashboardDossierFromJSON(json: any): ETypeDashboardDossier {
    return ETypeDashboardDossierFromJSONTyped(json, false);
}

export function ETypeDashboardDossierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ETypeDashboardDossier {
    return json as ETypeDashboardDossier;
}

export function ETypeDashboardDossierToJSON(value?: ETypeDashboardDossier | null): any {
    return value as any;
}

